import React, { useState, useEffect, useRef } from 'react';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const textRef = useRef(null);
  const aboutScrollRef = useRef(null);

  
  useEffect(() => {
    if (window.innerWidth <= 900 && aboutScrollRef.current) {
      aboutScrollRef.current.scrollLeft = 0;
    }
  }, []);

  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    const currentRef = textRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  
  const animateText = (text) => {
    return text.split(' ').map((word, index) => (
      <span
        key={index}
        style={{
          display: 'inline-block',
          marginRight: '0.3em',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: `all 0.6s cubic-bezier(0.4, 0, 0.2, 1) ${index * 0.1}s`
        }}
      >
        {word}
      </span>
    ));
  };

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .about-section {
            padding-top: 20px !important;
          }
        }
      `}</style>
      <section id="about-section" className="about-section" style={{ padding: '60px 20px 0', color: '#fff', scrollMarginTop: '80px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          
          {}
          <div style={{ textAlign: 'center', marginBottom: '0.8rem' }}>
            <h2 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: '100',
              color: 'white',
              marginBottom: '0.2rem',
              letterSpacing: '0.05em'
            }}>
              ABOUT US
            </h2>
            <p style={{
              fontSize: '1.2rem',
              color: '#9ca3af',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              DIFFERENT BY DESIGN
            </p>
          </div>

          {}
          <div style={{
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: '16px',
            overflow: 'hidden',
            marginBottom: '0.6rem'
          }}>
            
            {}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundSize: '400px 400px',
              backgroundPosition: 'right center',
              backgroundRepeat: 'no-repeat',
              opacity: '0.03',
              filter: 'blur(1px)',
              pointerEvents: 'none'
            }} />

            <div style={{ position: 'relative', zIndex: 2, padding: '0rem' }}>
              
              {}
              <div ref={textRef} style={{ marginBottom: '0.6rem' }}>
                <div style={{
                  fontSize: '1.1rem',
                  color: '#cbd5e1',
                  lineHeight: '1.8',
                  marginBottom: '0.4rem',
                  textAlign: 'center'
                }}>
                  <p style={{ marginBottom: '0.3rem', textAlign: 'center' }}>
                    {animateText("Founded with a vision to revolutionize the way the world views space access, our company aims to stand at the forefront of efficient small / medium payload to orbit.")}
                  </p>
                  <p>
                    {animateText("Our commitment to environmental sustainability, reliability, and fiscal efficiency will make us a trusted partner for leading satellite companies worldwide, delivering solutions that define the future of orbital logistics to better the lives of everyone on this Earth we share.")}
                  </p>
                </div>
              </div>

              {}
              <div
                className="about-cards-scroll"
                ref={aboutScrollRef}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '2rem',
                  marginBottom: '0.6rem',
                  overflowX: 'auto',
                  whiteSpace: 'nowrap',
                  WebkitOverflowScrolling: 'touch',
                  scrollbarWidth: 'thin',
                }}
              >
                      {}
                      <style>{`
                        .about-cards-scroll {
                          display: flex !important;
                          flex-direction: row;
                          overflow-x: auto !important;
                          gap: 1.2rem !important;
                          padding-bottom: 0.5rem;
                          scrollbar-width: thin;
                          -webkit-overflow-scrolling: touch;
                          justify-content: center !important;
                          margin-left: 0 !important;
                        }
                        @media (max-width: 900px) {
                          .about-cards-scroll {
                            justify-content: flex-start !important;
                          }
                        }
                        .about-cards-scroll > div {
                          min-width: 250px;
                          flex: 0 0 auto;
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                        }
                      `}</style>
                 {[
                   { title: "AURORA", desc: "The inaugural engine that started Aluren" },
                   { title: "EVE", desc: "Our first vehicle platform revolutionizing LEO accessibility" },
                   { title: "KRATOS", desc: "The next generation of heavy lift vehicles" },
                   { title: "ALUREN", desc: "The team changing how the world views orbital logistics" }
                 ].map((value, index) => (
                   <div key={index} className="about-value-box" style={{
                     minWidth: '220px',
                     maxWidth: '240px',
                     flex: '1 1 0',
                     padding: '2rem 1.2rem',
                     backgroundColor: 'transparent',
                     border: '1px solid transparent',
                     borderRadius: '12px',
                     textAlign: 'center',
                     transition: 'all 0.3s ease, border-color 0.3s ease',
                     cursor: 'pointer',
                     outline: 'none',
                     margin: '0 0.5rem',
                     boxSizing: 'border-box',
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     justifyContent: 'center',
                     fontFamily: 'inherit',
                   }}
                   onMouseEnter={(e) => {
                     e.currentTarget.style.transform = 'translateY(-5px)';
                     e.currentTarget.style.boxShadow = '0 0 20px rgba(82, 39, 255, 0.6), 0 8px 24px rgba(82, 39, 255, 0.3)';
                     e.currentTarget.style.borderColor = '#5227FF';
                   }}
                   onMouseLeave={(e) => {
                     e.currentTarget.style.transform = 'translateY(0)';
                     e.currentTarget.style.boxShadow = 'none';
                     e.currentTarget.style.borderColor = 'transparent';
                   }}
                   >
                     <h3 style={{
                       fontSize: '1.1rem',
                       fontWeight: '700',
                       marginBottom: '0.5rem',
                       color: 'white',
                       letterSpacing: '0.03em',
                       lineHeight: '1.2',
                       wordBreak: 'break-word',
                       whiteSpace: 'normal',
                       overflowWrap: 'break-word',
                     }}>
                       {value.title}
                     </h3>
                     <p style={{
                       color: '#9ca3af',
                       lineHeight: '1.5',
                       fontSize: '0.98rem',
                       margin: 0,
                       wordBreak: 'break-word',
                       whiteSpace: 'normal',
                       overflowWrap: 'break-word',
                       display: 'block',
                       textAlign: 'center',
                     }}>
                       {value.desc}
                     </p>
                   </div>
                 ))}
                    <style>{`
                      .about-cards-scroll {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        gap: 0.5rem;
                        overflow-x: auto;
                        overflow-y: hidden;
                        -webkit-overflow-scrolling: touch;
                        scrollbar-width: thin;
                        scrollbar-color: #5227FF #18181b;
                      }
                      .about-value-box {
                        box-shadow: none;
                        word-break: break-word;
                        white-space: normal;
                        flex: 0 0 auto;
                      }
                      .about-value-box:hover {
                        box-shadow: 0 0 20px rgba(82, 39, 255, 0.6), 0 8px 24px rgba(82, 39, 255, 0.3);
                        border-color: #5227FF;
                      }
                      @media (max-width: 900px) {
                        .about-cards-scroll {
                          flex-wrap: nowrap !important;
                          overflow-x: auto;
                          overflow-y: hidden;
                          gap: 0.5rem;
                          padding-left: 0;
                          padding-right: 8vw;
                          margin-left: 0;
                           min-width: 100vw; /* Moved inside the selector block */
                        }
                        .about-value-box {
                          min-width: 180px;
                          max-width: 70vw;
                          padding: 1.2rem 0.5rem;
                          word-break: break-word;
                          white-space: normal;
                          flex: 0 0 auto;
                        }
                      }
                    `}</style>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default About;